/** Entry point: wire the token prompter, mount the shell, start the router. */

import "./styles/index.css";

import { registerTokenPrompter, requireToken } from "./api/auth";
import { routes } from "./router/routes";
import { createRouter } from "./router/router";
import { notFoundPage } from "./pages/notFoundPage";
import { createShell } from "./ui/shell";
import { createTokenPrompter } from "./ui/tokenPrompt";

function mount(): void {
  const root = document.getElementById("app");
  if (root === null) {
    throw new Error("Missing #app root element.");
  }

  registerTokenPrompter(createTokenPrompter());

  const shell = createShell();
  root.replaceChildren(shell.root);

  const router = createRouter({
    outlet: shell.outlet,
    routes,
    fallback: notFoundPage,
    onNavigate: (context) => {
      shell.setActivePath(context.path);
    },
  });

  // Ask for the token before the first page fires its requests, so the user
  // sees one dialog rather than a dialog racing a wall of error states.
  void requireToken()
    .catch(() => undefined)
    .finally(() => {
      router.start();
    });
}

mount();
